import React from 'react';
import PropTypes from 'prop-types';
import PmTicketSignalLevelFields from "./PmTicketSignalLevelFields";
import MenuItem from "material-ui/MenuItem";

const PmTicketSignalLevelsForm = (props) => {
    const {
        signalLevelsStore,
        signalLevelsDetails,
        configs,
        handleValueChange,
    } = props;

    return (
        <div>
            {
                configs.map(field => {
                    return <PmTicketSignalLevelFields
                        value={signalLevelsStore ? signalLevelsStore.get(field.id) : ''}
                        name={field.name}
                        error={signalLevelsDetails ? signalLevelsDetails.get(field.id + 'Error') : ''}
                        id={field.id}
                        handleValueChange={handleValueChange}
                    />
                })
            }
        </div>
    );
}


PmTicketSignalLevelsForm.propTypes = {
    workOrderActions: PropTypes.object,
    orderId: PropTypes.string,
    techId: PropTypes.string
};

export default PmTicketSignalLevelsForm;



// WEBPACK FOOTER //
// ./src/components/signal-levels/PmTicketSignalLevelsForm.js